import { CloseOutlined } from '@ant-design/icons';
import { Button, Spin } from 'antd';
import { UploadDragger, Preview } from 'features/absence/absence-import/ui';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from 'app/store';
import { uiModel } from 'entities/ui';
import { useAbsenceImportMutation } from 'app/services/edpApiV1/absence';
import { useEffect } from 'react';
import { ChangeFormValueModal } from 'shared/components/ChangeFormValueModal';
import { useSetCurrentOrganizationMutation } from 'app/services/edpApiV1/viewer';
import { useNotifications } from 'shared/hooks/use-notifications';
import { getErrorData } from 'shared/helpers/utils';
import style from './index.module.scss';

export const AbsenceImportWidget = () => {
  const navigate = useNavigate();
  const dataTable = useAppSelector(uiModel.Absence.selectors.selectAllRows);
  const [triggerImport, { isLoading: isLoadingAbsenceImport, data, reset, isError, error }] = useAbsenceImportMutation({
    selectFromResult: result => ({ ...result, error: getErrorData(result.error) }),
    fixedCacheKey: 'absenceImport',
  });
  const [triggerOrganization, { isLoading: isLoadingSetCurrentOrganization }] = useSetCurrentOrganizationMutation({
    fixedCacheKey: 'setCurrentOrganization',
  });

  const isSuccess = data?.status == 'OK';

  useNotifications(isSuccess, isError, 'Неявки успешно импортированы', error?.message, reset);

  useEffect(() => {
    // При успешном импорте неявок переходим на предыдущую страницу и удаляем текущий результата из кеша
    if (isSuccess || isLoadingSetCurrentOrganization) {
      navigate(-1);
      reset();
    }
  }, [data, navigate, reset, isLoadingSetCurrentOrganization]);

  return (
    <div>
      <Spin spinning={isLoadingAbsenceImport}>
        <div className={style.header}>
          <h3>Импортировать неявки</h3>
          <Button type="text" icon={<CloseOutlined />} onClick={() => navigate(-1)} />
        </div>
        <div className={style.wrap}>
          {/* <div>
            Импортируйте неявки по <Link to={''}>шаблону</Link>.
          </div> */}
          <UploadDragger />
          {!!dataTable.length && <Preview />}
        </div>
      </Spin>
      {!isLoadingSetCurrentOrganization && (
        <ChangeFormValueModal
          title="Вы действительно хотите перейти не завершив импорт?"
          message={
            'Вы загрузили данные из файла, но не импортировали их в систему, действительно хотите покинуть страницу?'
          }
          when={!!dataTable.length}
        />
      )}
    </div>
  );
};
